export const escapeRegExp = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

export const regExp = s => {
    const p = s.split(/\s+/).filter(Boolean).map(escapeRegExp).join('|');
    return p ? new RegExp(`(${p})`, 'gi') : /.*/gi;
};

export const highlight = regexp => text =>
    text.replace(regexp, '<mark>$1</mark>');

export const matchLength = regexp => text =>
    (text.match(regexp) || []).map(m => m.length).reduce((a, b) => a + b, 0);



// WEBPACK FOOTER //
// ./src/portal/components/sp-global-search/functions.js